export const environment = {
  production: true,
  allowedRole: 'default-roles',
};
